import { configureStore } from '@reduxjs/toolkit';

// Accounts Reports Reducers
import closingReportReducer from '../features/AccountsReports/closingReportSlice'

// Admin Management Reducers
import tillsReducer from '../features/AdminManagement/tillsSlice'
import dailyClosingReducer from '../features/AdminManagement/dailyClosingSlice';
import openingReducer from '../features/opening/openingSlice';
import closingReducer from '../features/closing/closingSlice';
import SetUserRightsReducer from '../features/AdminManagement/setUserRightsSlice';
import restartServicesSliceReducer from '../features/AdminManagement/restartServicesSlice';
import singleDataScreenReducer from '../features/AdminManagement/singleFieldSlice';
import recipeReducer from '../features/AdminManagement/recipeSlice';
import productionReducer from '../features/AdminManagement/productionSlice';
import auditReducer from '../features/AdminManagement/auditSlice'
import BranchesReducer from '../features/AdminManagement/branchSlice'
import feedbackReducer from '../features/AdminManagement/feedbackSlice'

// General Management Reducers
import partiesInformationReducer from '../features/GeneralManagement/partiesInformationSlice'
import itemCategoryReducer from '../features/GeneralManagement/itemCategorySlice'
import itemHeadReducer from '../features/GeneralManagement/itemHeadsSlice'
import ItemCompany from '../features/GeneralManagement/itemCompanySlice'

// Stock Management
import itemsInformationReducer from '../features/StockManagement/itemsInformationSlice'
import counterSalesReducer from '../features/StockManagement/counterSalesSlice'
import prReducer from '../features/StockManagement/Purchases/prSlice'
import poReducer from '../features/StockManagement/Purchases/poSlice'
import pdReducer from '../features/StockManagement/Purchases/pdSlice'
import piReducer from '../features/StockManagement/Purchases/piSlice'
import posReducer from '../features/StockManagement/posSlice'
import posBusinessReducer from '../features/StockManagement/posBusinessSlice'
import printerAssignmentReducer from '../features/setup/printerAssignmentSlice'
import kitchenReducer from '../features/setup/kitchenSlice'
import categoryKitchenReducer from '../features/setup/categoryKitchenSlice'
import dispatchCounterReducer from '../features/setup/dispatchCounterSlice'
import takeawayCounterReducer from '../features/setup/takeawayCounterSlice'
import dineInTableReducer from '../features/setup/dineInTableSlice'
import dineInWaitlistReducer from '../features/setup/dineInWaitlistSlice'
import dealsReducer from '../features/setup/dealsSlice'
import promoCodesReducer from '../features/setup/promoCodesSlice'

// Stock Reports
import salesDashbaordReducer from '../features/StockReports/salesDashbaordSlice'
import salesReportReducer from '../features/StockReports/salesReportSlice'
import salesByTypeReducer from '../features/StockReports/salesByTypeSlice'
import itemWiseSalesReducer from '../features/StockReports/itemWiseSalesSlice'

// Setup Reducers
import authReducer from '../features/auth/authSlice'
import menuReducer from '../features/menu/menuSlice'

// Useable Reducers
import useableReducer from '../features/setup/useableSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menus: menuReducer,
    tills: tillsReducer,
    clsng: dailyClosingReducer,
    opening: openingReducer,
    closing: closingReducer,
    clsngRpt: closingReportReducer,
    itemsInf: itemsInformationReducer,
    partyInf: partiesInformationReducer,
    ru: useableReducer,
    cs: counterSalesReducer,
    sur: SetUserRightsReducer,
    sd: salesDashbaordReducer,
    sr: salesReportReducer,
    sbt: salesByTypeReducer,
    iwsr: itemWiseSalesReducer,
    rs: restartServicesSliceReducer,
    ic: itemCategoryReducer,
    ih: itemHeadReducer,
    itmCmp: ItemCompany,
    sf: singleDataScreenReducer,
    pr: prReducer,
    po: poReducer,
    recipe: recipeReducer,
    production: productionReducer,
    pd: pdReducer,
    pi: piReducer,
    audit: auditReducer,
    branches: BranchesReducer,
    fb: feedbackReducer,
    pos: posReducer,
    posBusiness: posBusinessReducer,
    printerAssignment: printerAssignmentReducer,
    kitchens: kitchenReducer,
    categoryKitchen: categoryKitchenReducer,
    dispatchCounters: dispatchCounterReducer,
    takeawayCounters: takeawayCounterReducer,
    dineInTables: dineInTableReducer,
    dineInWaitlist: dineInWaitlistReducer,
    deals: dealsReducer,
    promoCodes: promoCodesReducer,
  },
});
